import React from 'react';

import { useTheme } from '@emotion/react';
import {
  Button,
  Card,
  Divider,
  Grid,
  styled,
  useMediaQuery,
} from '@mui/material';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import FlexRowAlign from 'components/flexbox/FlexRowAlign';
import { H3, H6, Small } from 'components/Typography';
import { MessagesSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const StyledCard = styled(Card)(({ theme, isTablet }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '2rem 2rem 2rem 2rem',
  justifyContent: 'space-between',
  flexDirection: 'column',
  border: 'none',
  borderRadius: isTablet ? '0px' : '24px',
  boxShadow: isTablet ? 'none' : '0px 4px 20px rgba(0, 0, 0, 0.08)',
  borderBottom: isTablet ? '1px solid #E1E1E1' : 'none',
  [theme.breakpoints.down('sm')]: {
    padding: '1.5rem 0rem 1.5rem 0rem',
    textAlign: 'center',
    marginBottom: '1rem',
  },
}));

const ReplyCard = ({ avatar, username, date, reply }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  return (
    <StyledCard isTablet={isTablet}>
      <FlexBox
        px={isMobile ? 2 : 0}
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        gap={isMobile ? 2 : 0}
      >
        <Grid
          mb={isMobile ? 1 : 0}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <FlexBox
            alignItems="center"
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate('/naver/community/profile/other')}
          >
            <AppAvatar
              alt="avatar"
              src={avatar}
              style={{ width: '48px', height: '48px' }}
            />
            <FlexBox flexDirection="column" ml={1.5}>
              <H3
                sx={{
                  whiteSpace: 'nowrap',
                  color: theme.palette.primary.dark,
                }}
              >
                {username}
              </H3>
              <Small mb={0.5} style={{ textAlign: 'left' }}>
                {date}
              </Small>
            </FlexBox>
          </FlexBox>
        </Grid>

        <FlexRowAlign gap={1} sx={{ width: isMobile ? '100%' : 'fit-content' }}>
          <Button
            variant="outlined"
            size="small"
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.primary.mainBlue,
              color: '#ffffff',
              width: isMobile ? '100%' : 'fit-content',
              '&:hover': {
                backgroundColor: theme.palette.primary.mainBlue,
                color: '#ffffff',
                borderColor: theme.palette.primary.mainBlue,
              },
            }}
          >
            <MessagesSquare
              size={20}
              color={theme.palette.primary.white}
              style={{ marginRight: 8 }}
            />
            채팅 · 전화상담
          </Button>
        </FlexRowAlign>
      </FlexBox>

      <Divider
        style={{
          height: '1px',
          margin: isMobile ? '20px 0rem' : '20px -2rem',
          backgroundColor: '#E1E1E1',
          width: 'calc(100% + 4rem)',
        }}
      />

      <H6
        py={2}
        px={isMobile ? 2 : 0}
        sx={{ textAlign: 'left', width: '100%' }}
      >
        {reply.split('\n').map((item, key) => (
          <React.Fragment key={key}>
            {item}
            <br />
          </React.Fragment>
        ))}
      </H6>
    </StyledCard>
  );
};

export default ReplyCard;
